import { useEffect } from 'react';
import { useSearchParamsMethods } from '../../../../shared/packages/searchParamsManager';
import { filterNormalizers } from '../../constants/filter';

const asIs = (value) => value;

export const useReviseFilterValue = ({ name, ids, multiple = false }) => {
  const { getParams, setParams } = useSearchParamsMethods();

  useEffect(() => {
    const normalizer = filterNormalizers[name] ?? asIs;
    const value = normalizer(getParams(name));

    if (!value) return;

    if (!ids) {
      setParams({ [name]: undefined });
      return;
    }

    if (multiple) {
      const filtered = value.filter((val) => ids.has(val));

      if (filtered.length !== value.length) {
        setParams({ [name]: filtered.length ? filtered : undefined });
      }

      return;
    }

    if (!ids.has(value)) {
      setParams({ [name]: undefined });
    }
  }, [name, multiple, ids, setParams, getParams]);
};
